import { ScrollSection } from "@/components/main-page/ScrollSection";
import { cn } from "@/lib/cn";

const MILESTONES = [
  { date: "Aug 2025", text: "Cosine X Ltd incorporated." },
  { date: "Dec 2025", text: "Angel round closed." },
  { date: "Jan 2026", text: "Founding team goes full-time." },
  { date: "Jan 2026", text: "XENI goes live. Beta clients onboarded in the UK." },
  { date: "Apr 2026", text: "Robolab X launching. Exclusive school partnership." },
  { date: "Apr 2026", text: "XENI expanding to Australia and Singapore." },
  { date: "Q2 2026", text: "Seed round (in progress)." },
];

export function MilestonesSection() {
  return (
    <ScrollSection id="milestones" title="Where we are" compact>
      {/* Desktop: horizontal */}
      <div className="hidden md:block relative">
        {/* Track line */}
        <div className="absolute top-3 left-0 right-0 h-px bg-[var(--color-border)]" />

        <div className="grid" style={{ gridTemplateColumns: `repeat(${MILESTONES.length}, 1fr)` }}>
          {MILESTONES.map((m, i) => (
            <div key={i} className="relative pt-8 pr-6">
              {/* Dot */}
              <div
                className={cn(
                  "absolute top-0 w-6 h-6 rounded-full border-2 flex items-center justify-center",
                  i === MILESTONES.length - 1
                    ? "border-amber-500 bg-amber-500/10"
                    : "border-[var(--color-fg)] bg-[var(--color-bg)]",
                )}
              >
                <div
                  className={cn(
                    "w-2 h-2 rounded-full",
                    i === MILESTONES.length - 1 ? "bg-amber-500" : "bg-[var(--color-fg)]",
                  )}
                />
              </div>
              <div className="text-[10px] font-[family-name:var(--font-mono)] text-[var(--color-fg-tertiary)] uppercase tracking-widest mb-2">
                {m.date}
              </div>
              <p className="text-sm text-[var(--color-fg-secondary)] leading-relaxed">
                {m.text}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Mobile: vertical */}
      <div className="md:hidden relative">
        {/* Track line */}
        <div className="absolute top-3 bottom-3 left-3 w-px bg-[var(--color-border)]" />

        <div className="space-y-6">
          {MILESTONES.map((m, i) => (
            <div key={i} className="relative pl-10">
              {/* Dot */}
              <div
                className={cn(
                  "absolute left-0 top-0.5 w-6 h-6 rounded-full border-2 flex items-center justify-center",
                  i === MILESTONES.length - 1
                    ? "border-amber-500 bg-amber-500/10"
                    : "border-[var(--color-fg)] bg-[var(--color-bg)]",
                )}
              >
                <div
                  className={cn(
                    "w-2 h-2 rounded-full",
                    i === MILESTONES.length - 1 ? "bg-amber-500" : "bg-[var(--color-fg)]",
                  )}
                />
              </div>
              <div className="text-[10px] font-[family-name:var(--font-mono)] text-[var(--color-fg-tertiary)] uppercase tracking-widest mb-1">
                {m.date}
              </div>
              <p className="text-sm text-[var(--color-fg-secondary)] leading-relaxed">
                {m.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </ScrollSection>
  );
}
